export default {
  name: 'RequestDemo',
  path: '/request-demo',
  meta: {
    title: 'Request Demo - T4translate'
  }
};
